import React from "react";
import { MENUS } from "../../../../../utils/ui.constants";
import SidebarList from "./SidebarList";
import { Box, Divider } from "@mui/material";

function SidebarWide() {
  return (
    <>
      {MENUS.map((menu, index) => {
        return (
          <React.Fragment key={index}>
            <SidebarList subheaderText={menu.subheader} items={menu.items} />
            {index < MENUS.length - 1 && (
              <Box sx={{ px: 2 }}>
                <Divider />
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default SidebarWide;
